import bcrypt from 'bcryptjs';

export const verifyCachedOrderOtp = async (order, submittedOtp) => {
  if (!order) {
    return { valid: false, message: 'Order not found in offline cache.' };
  }

  if (!order.otp) {
    return {
      valid: false,
      message: 'OTP is not available offline for this order. Connect to the internet and refresh.',
    };
  }

  if (order.otp_expires_at && new Date() > new Date(order.otp_expires_at)) {
    return { valid: false, message: 'OTP has expired. Please request a new one when online.' };
  }

  const isMatch = await bcrypt.compare(String(submittedOtp), order.otp);
  if (!isMatch) {
    return { valid: false, message: 'Invalid OTP' };
  }

  return { valid: true };
};

export const toCacheableUndeliveredOrder = (order) => {
  if (!order || (order.status_id !== 2 && order.status_id !== 4)) {
    return null;
  }

  return {
    id: order.id,
    waybill_no: order.waybill_no,
    order_no: order.order_no,
    customer_name: order.customer_name,
    customer_phone: order.customer_phone,
    customer_address: order.customer_address,
    status_id: order.status_id,
    createdAt: order.createdAt,
    company_id: order.company_id,
    otp: order.otp || null,
    otp_expires_at: order.otp_expires_at || null,
  };
};
